<template>
  <div class="tree">
    <TreeItem
      v-for="item in props.items"
      :key="item.id"
      :item="item"
      :expanded="expanded"
      @toggleExpanded="toggleExpanded"
    >
      <template #item="{ item: innerItem }">
        <slot
          name="item"
          :item="innerItem"
        />
      </template>
    </TreeItem>
    <div
      v-if="!props.items.length"
      class="empty"
    >
      Ничего не найдено
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import TreeItem from './TreeItem.vue'
import { getAllIds, type ITreeItem } from './search'


const props = defineProps<{
  items: ITreeItem[]
  showExpanded?: boolean
}>()

const expanded = ref<ITreeItem['id'][]>([])

watch(
  // watch both: when items changed, but tree should stay expanded
  () => [props.showExpanded, props.items],
  ([expand]) => {
    expanded.value = expand ? getAllIds(props.items) : []
  },
  { immediate: true },
)

function toggleExpanded(id: ITreeItem['id']) {
  const i = expanded.value.indexOf(id)

  if (i >= 0) {
    expanded.value.splice(i, 1)
  } else {
    expanded.value.push(id)
  }
}

</script>

<style scoped>
.tree {
  overflow-x: auto;
  overflow-y: auto;

  .empty {
    margin-bottom: var(--ps-padding-s);
  }
}
</style>
